import { useState } from "react";
import PropTypes from "prop-types";
import { Modal, Button, Select } from "common-components";
import { UiModalTitle, StyledUpdateStatus } from "./UpdateStatusModal.style";

export const UpdateStatusModal = ({ count, statusOptions, isLoading, onOk, onCancel }) => {
	const [status, setStatus] = useState(null);

	return (
		<Modal
			title={<UiModalTitle>請選擇回報狀態</UiModalTitle>}
			visible={true}
			width="480px"
			onCancel={onCancel}
			footer={
				<>
					<Button variant="white" full={false} onClick={onCancel}>
						取消
					</Button>
					<Button variant="orange" full={false} loading={isLoading} disabled={!status} onClick={() => onOk(status)}>
						確認
					</Button>
				</>
			}>
			<StyledUpdateStatus>
				<div className="hint">
					已勾選 <span>{count}</span> 筆，請選擇要修改的狀態
				</div>
				<Select
					placeholder="請選擇回報狀態"
					options={statusOptions}
					value={status}
					onChange={(val) => setStatus(val ?? null)}
				/>
			</StyledUpdateStatus>
		</Modal>
	);
};

UpdateStatusModal.propTypes = {
	count: PropTypes.number,
	statusOptions: PropTypes.array,
	isLoading: PropTypes.bool,
	onOk: PropTypes.func,
	onCancel: PropTypes.func,
};
